import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { api, errorMessage } from "../api/client";

export type SsoConnection = { id: string; name: string; protocol: "oidc" | "saml"; is_active: boolean; enforce: boolean; email_domains: string[]; issuer: string; client_id: string; has_client_secret: boolean; scopes: string; saml_metadata_url: string; saml_entity_id: string; jit_provisioning: boolean; default_roles: string[]; scim_enabled: boolean; scim_token_prefix: string; created_at: string };

async function unwrap<T>(p: Promise<{ data?: unknown; error?: unknown }>): Promise<T> {
  const { data, error } = await p;
  if (error) throw error;
  return data as T;
}

export function useSsoConnections() {
  return useQuery({ queryKey: ["sso-connections"], queryFn: async () => (await unwrap<{ results: SsoConnection[] }>(api.GET("/api/v1/accounts/sso-connections/"))).results });
}
export function useSaveSso() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, ...body }: Partial<SsoConnection> & { id?: string; client_secret?: string }) => id
      ? unwrap<SsoConnection>(api.PATCH("/api/v1/accounts/sso-connections/{id}/", { params: { path: { id } }, body: body as never }))
      : unwrap<SsoConnection>(api.POST("/api/v1/accounts/sso-connections/", { body: body as never })),
    onSuccess: () => void qc.invalidateQueries({ queryKey: ["sso-connections"] }),
  });
}
export function useDeleteSso() {
  const qc = useQueryClient();
  return useMutation({ mutationFn: async (id: string) => { const { error } = await api.DELETE("/api/v1/accounts/sso-connections/{id}/", { params: { path: { id } } }); if (error) throw new Error(errorMessage(error)); }, onSuccess: () => void qc.invalidateQueries({ queryKey: ["sso-connections"] }) });
}
export function useScimToken() {
  const qc = useQueryClient();
  return useMutation({ mutationFn: (id: string) => unwrap<{ token: string; base_url: string }>(api.POST("/api/v1/accounts/sso-connections/{id}/scim-token/", { params: { path: { id } } })), onSuccess: () => void qc.invalidateQueries({ queryKey: ["sso-connections"] }) });
}
